import React from 'react'
import { Box, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { FranchiseeProcessingForm, IFranchiseeProcessingFormValues } from '../Forms'
import { useMutation } from '@apollo/react-hooks'
import {
  IFranchisee,
  IUpdateFranchiseeProcessingData,
  IUpdateFranchiseeProcessingVariables,
} from '../../../graphql/types/franchisee'
import { UPDATE_FRANCHISEE_PROCESSING_MUTATION } from '../../../graphql/queries/franchisee'

interface IProps {
  franchisee: IFranchisee
  open: boolean
  onCancel: () => void
}

export const FranchiseeProcessingModal: React.FC<IProps> = ({ franchisee, open, onCancel }) => {
  const [updateProcessing, { error }] = useMutation<
    IUpdateFranchiseeProcessingData,
    IUpdateFranchiseeProcessingVariables
  >(UPDATE_FRANCHISEE_PROCESSING_MUTATION)

  const handleSubmit = async (values: IFranchiseeProcessingFormValues) => {
    await updateProcessing({
      variables: { franchiseeId: franchisee.id, input: values },
    })

    onCancel()
  }

  return (
    <Dialog open={open} maxWidth='sm' fullWidth onClose={onCancel}>
      <DialogTitle id='form-dialog-title'>Процессинг</DialogTitle>
      <DialogContent>
        {!!error && (
          <Box mb={3}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}
        <FranchiseeProcessingForm franchisee={franchisee} onSubmit={handleSubmit} onCancel={onCancel} />
      </DialogContent>
    </Dialog>
  )
}
